export default __webpack_public_path__ + "static/media/Mark-5-HUD-Pop-Up (1 Layer).1ca63338.jpg";